jQuery(document).ready(function() {
var productSliderWrapper = jQuery('.product-slider-wrapper');
if(productSliderWrapper){
    var getWindowWidth = jQuery(window).width();
    var settings = {
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        mobileFirst: true,
        swipeToSlide: true,
        prevArrow: jQuery('.slick-prev'),
        nextArrow: jQuery('.slick-next'),
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            }
        ]
    }
productSliderWrapper.slick(settings);

if(getWindowWidth < 992){
productSliderWrapper.slick('unslick');
  productSliderWrapper.slick(settings);
}

if(getWindowWidth < 768){
  productSliderWrapper.slick('unslick');
productSliderWrapper.slick(settings);
}
}
});
